import { MedicineSimple } from '@dreryk/drerykweb-medicine-api';

import { RuleVerificationResult } from '~libs.shared.prescription';

import { RuleVerificationResultsStatus } from '../common/RuleVerificationResultsStatus';

import { MedicineParametersChangedStatus } from './medicineParametersChanged/MedicineParametersChangedStatus';
import { PatientInPersonExaminationRequiredStatus } from './patientInPersonExaminationRequired/PatientInPersonExaminationRequiredStatus';

type DraftStandardPrescriptionStatusesProps = {
   readonly previouslyUsedMedicineId: number | undefined;
   readonly medicine: MedicineSimple;
   readonly inPersonExaminationPerformed: boolean;
   readonly ruleVerificationResults: RuleVerificationResult[] | undefined;
};

export const DraftStandardPrescriptionStatuses = (props: DraftStandardPrescriptionStatusesProps): JSX.Element => {
   const inPersonExaminationRequired = Boolean(
      props.medicine.inPersonExaminationRequired && !props.inPersonExaminationPerformed
   );

   return (
      <>
         {props.previouslyUsedMedicineId ? <MedicineParametersChangedStatus /> : null}
         {inPersonExaminationRequired ? <PatientInPersonExaminationRequiredStatus /> : null}
         <RuleVerificationResultsStatus ruleVerificationResults={props.ruleVerificationResults} />
      </>
   );
};
